/**
 * @deprecated One URL param per filter. Superseded by the `filtersPayload` slot (declared in
 * `modules/leads-search/constants/routing.ts`), which carries any filter in a single stringified object.
 * These stay registered so links minted before it existed keep seeding; nothing should mint them.
 */
export const SEARCH_FILTERS_ROUTE_PARAMS = {
    siteTags: { dynamic: true },
    industry: { dynamic: true },
};
